import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { NJAvatarRoot } from '@engie-group/fluid-design-system-react';
import styles from './NJChatBlock.module.css';

// eslint-disable-next-line react-refresh/only-export-components
export const messageSource = {
  received: 'received',
  sent: 'sent'
} as const;

export type MessageSource = (typeof messageSource)[keyof typeof messageSource];

/**
 * Interface for chat block properties.
 *
 * @interface IChatBlockProps
 */
export type IChatBlockProps = (
  | {
  source: typeof messageSource.received;
  children: React.ReactElement | React.ReactElement[];
}
  | {
  source: typeof messageSource.sent;
  children: React.ReactElement;
}
  ) &
  ComponentPropsWithoutRef<'div'>;

export const NJChatBlock = forwardRef<HTMLDivElement, IChatBlockProps>(
  ({ children, source, ...props }, ref) => {
    return (
      <>
        <div
          ref={ref} {...props} className={`
                        ${styles['nj-chat-block']} 
                        ${props.className || ''} 
                        ${source === messageSource.received ? styles['nj-chat-block__received'] : ''}
                        ${source === messageSource.sent ? styles['nj-chat-block__sent'] : ''}
                    `}
        >
          {source === messageSource.received ? (
            <>
              <NJAvatarRoot
                size="sm"
                className={styles['nj-chat-block__avatar']}
                label="Responder"
                initials="AI"
              />

              <div className={styles['nj-chat-block__messages']}>{children}</div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </>
    );
  }
);
